import {UI, rgba} from "../uiTokens";

/** Rounded input with the blue accent focus ring — shared by every edit-menu tab. */
export const fieldSx = {
    "& .MuiOutlinedInput-root": {
        borderRadius: "8px",
        backgroundColor: UI.surface,
        "& fieldset": {borderColor: rgba(UI.accent, 0.2)},
        "&:hover fieldset": {borderColor: rgba(UI.accent, 0.35)},
        "&.Mui-focused fieldset": {borderColor: UI.accent, borderWidth: "1px"},
    },
    "& .MuiInputLabel-root.Mui-focused": {color: UI.accent},
};

export const checkboxSx = {
    p: 0.5,
    color: rgba(UI.ink, 0.35),
    "&.Mui-checked": {color: UI.accent},
};

export const switchSx = {
    "& .MuiSwitch-switchBase.Mui-checked": {color: UI.accent},
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {backgroundColor: UI.accent},
};

export const controlLabelSx = {fontSize: 12.5, color: UI.ink};

/** Uppercase kicker for section headers / table headers. */
export const sectionLabelSx = {
    fontSize: 10.5,
    fontWeight: 700,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: UI.muted,
};

/** Compact icon button that lifts to the accent colour on hover. */
export const iconBtnSx = {
    color: UI.muted,
    "&:hover": {backgroundColor: rgba(UI.accent, 0.1), color: UI.accent},
};

/** Same, but destructive. */
export const iconBtnDangerSx = {
    color: UI.muted,
    "&:hover": {backgroundColor: rgba(UI.danger, 0.1), color: UI.danger},
};

/** Compact hairline-bordered table used for tool / skill lists in the AI tabs. */
export const settingsTableSx = {
    border: `1px solid ${rgba(UI.ink, 0.1)}`,
    borderRadius: "10px",
    borderCollapse: "separate",
    borderSpacing: 0,
    overflow: "hidden",
    "& .MuiTableCell-root": {borderColor: rgba(UI.ink, 0.06), py: 0.5, px: 1},
};

export const settingsTableHeadCellSx = {
    fontWeight: 700,
    fontSize: 10,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    color: UI.muted,
};

/** Card surface for modal dialogs opened from the edit menu. */
export const modalCardSx = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "92%",
    minWidth: 280,
    maxWidth: 460,
    maxHeight: "85vh",
    overflowY: "auto",
    bgcolor: UI.surface,
    borderRadius: "16px",
    border: `1px solid ${rgba(UI.ink, 0.08)}`,
    boxShadow: UI.shadow,
    p: 2.5,
    outline: "none",
};

/** Accent (primary) pill button. */
export const primaryBtnSx = {
    textTransform: "none",
    fontWeight: 600,
    borderRadius: "8px",
    backgroundColor: UI.accent,
    color: "#fff",
    boxShadow: "none",
    "&:hover": {backgroundColor: "#1f6bff", boxShadow: "none"},
    "&.Mui-disabled": {backgroundColor: rgba(UI.accent, 0.4), color: "#fff"},
};

/** Quiet secondary button. */
export const ghostBtnSx = {
    textTransform: "none",
    fontWeight: 600,
    borderRadius: "8px",
    color: UI.muted,
    "&:hover": {backgroundColor: rgba(UI.ink, 0.05), color: UI.ink},
};
